/* eslint-disable */
import React from 'react'
import { Link } from 'react-router-dom'
import { AlertCircle, ArrowLeft } from 'lucide-react'
import './NotFound.css'

function NotFound() {
    return (
        <div className="notfound-container">
            <div className="notfound-card">
                <div className="notfound-icon-wrap">
                    <AlertCircle
                        style={{
                            width: '48px',
                            height: '48px',
                            color: 'var(--primary)',
                        }}
                    />
                </div>
                <h1 className="notfound-title">404</h1>
                <h2 className="notfound-subtitle">Page Not Found</h2>
                <p className="notfound-text">
                    The page you are looking for might have been removed, had
                    its name changed, or is temporarily unavailable.
                </p>
                <Link to="/" className="notfound-home-btn">
                    <ArrowLeft style={{ width: '16px', height: '16px' }} />
                    <span>Go Back Home</span>
                </Link>
            </div>
        </div>
    )
}

export default NotFound
